<modal #modal>
    <div class="col-12">
        <div class="header col-12">
            Er du ny eller<br> eksisterende kunde?
        </div>
    </div>

    <div class="footer col-12">
        <button class="cta cta--primary cta--large" (click)="onNewCustomerClicked()"> Ny kunde</button>
        <button class="cta cta--secondary cta--large" (click)="onExistingCustomerClicked()"> Eksisterende kunde</button>
    </div>
</modal>